function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 13.915a1.5 1.5 0 10-1 0V17h1v-3.085z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 8V5.184C13 2.337 10.349 0 7.5 0S2 2.337 2 5.184V8H.776C.347 8 0 8.568 0 8.993v10.238c0 .425.347.769.776.769h13.448a.773.773 0 00.776-.77V8.994c0-.425-.347-.993-.776-.993H13zM7.5 2C5.542 2 4 3.153 4 5.184V8h7V5.184C11 3.154 9.458 2 7.5 2zM2 10v8h11v-8H2z"
});

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNSAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTMuOTE0NkM4LjU4MjYgMTMuNzA4NyA5IDEzLjE1MzEgOSAxMi41QzkgMTEuNjcxNiA4LjMyODQzIDExIDcuNSAxMUM2LjY3MTU3IDExIDYgMTEuNjcxNiA2IDEyLjVDNiAxMy4xNTMxIDYuNDE3NCAxMy43MDg3IDcgMTMuOTE0NlYxN0g4VjEzLjkxNDZaIiAvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzIDhWNS4xODM5NUMxMyAyLjMzNzQ2IDEwLjM0ODYgMCA3LjUgMEM0LjY1MTM5IDAgMiAyLjMzNzQ2IDIgNS4xODM5NVY4SDAuNzc1ODYyQzAuMzQ3MzY1IDggMCA4LjU2ODQ4IDAgOC45OTMzMVYxOS4yMzA4QzAgMTkuNjU1NiAwLjM0NzM2NSAyMCAwLjc3NTg2MiAyMEgxNC4yMjQxQzE0LjY1MjYgMjAgMTUgMTkuNjU1NiAxNSAxOS4yMzA4VjguOTkzMzFDMTUgOC41Njg0OCAxNC42NTI2IDggMTQuMjI0MSA4SDEzWk03LjUgMkM1LjU0MjA0IDIgNCAzLjE1MzM3IDQgNS4xODM5NVY4SDExVjUuMTgzOTVDMTEgMy4xNTMzNyA5LjQ1Nzk2IDIgNy41IDJaTTIgMTBWMThIMTNWMTBIMloiIC8+Cjwvc3ZnPgo=";
export { SvgLock as ReactComponent };